
import Vue from "vue";
import SubHeader from "@/views/layout/header/SubHeader.vue";
import Search from "@/components/Search.vue";
import { Component } from "vue-property-decorator";
import MenuFooter from "@/views/layout/footer/MenuFooter.vue";
import api from "@/api";
import TicketModel from "@/models/createTicket/TicketModel";
import utils from "@/utils";
import dayjs from "dayjs";
import WorkorderModel from "@/models/createTicket/WorkorderModel";
@Component({
  components: {
    SubHeader,
    Search,
    MenuFooter,
  },
})
export default class ListNotification extends Vue {
  mounted() {
    this.getDetailTicket(this.$route.params.id);
    this.getHistory(this.$route.params.id);
  }
  dayjs = dayjs;
  utils = utils;
  titlePage = "History";
  date = "21/JAN/2022";
  time = "12.30";
  title = "Cake Engine Breaking Down";
  subTitle = "Lorem Ipsum is simply text";
  status = "new";
  isOpen = "0";

  history = []
  ticket: WorkorderModel = new WorkorderModel();
  getDetailTicket(idTicket: string) {
    return new Promise((resolve, reject) => {
      api.ticket
        .getDetailTask2(idTicket)
        .then((response) => {
          if (response.data.code === 200) {
            this.ticket = Object.assign({}, response.data.data);
            resolve(response);
          }
        })
        .catch((err: any) => {
          reject(err);
          this.$swal("Error", err?.response?.data?.message, "error");
        });
    });
  }

  getHistory(idTicket: string) {
    return new Promise((resolve, reject) => {
      api.ticket
        .getHistory(idTicket)
        .then((response) => {
          if (response.data.code === 200) {
            this.history = response.data.data.sort((a, b) => new Date(b?.created_at).getTime() - new Date(a?.created_at).getTime());
            resolve(response);
          }
        })
        .catch((err: any) => {
          reject(err);
          this.$swal("Error", err?.response?.data?.message, "error");
        });
    });
  }
  get colorStatus() {
    if (this.ticket.status === "new") {
      return "cl-red";
    } else {
      return "cl-green-light";
    }
  }
  get pitaStatus() {
    if (this.ticket.status === "new") {
      return "new";
    } else {
      return "on-progress";
    }
  }
}
